module.exports = __webpack_public_path__ + "static/img/5.40bc228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/5.png
// module id = gXow
// module chunks = 35